module.exports = __webpack_public_path__ + "img/szamlazz-hu-agent-key-helper.d4358b41.gif";